import { useState, useEffect } from "react";

export default function useImageUrlToBase64(imageUrl: string): string {
  const [base64, setBase64] = useState("");

  useEffect(() => {
    if (!imageUrl) {
      return;
    }

    async function convertToBase64(url: string): Promise<string> {
      const response = await fetch(url);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    convertToBase64(imageUrl)
      .then((converted) => {
        // Strip the header from the converted string
        const base64Content = converted.substring(converted.indexOf(",") + 1);
        setBase64(base64Content);
      })
      .catch((err) => console.error(err));
  }, [imageUrl]);

  return base64;
}
